import { muiStyles } from 'utils/design';
import { colors } from 'styles/colors';

export const useStyles = muiStyles((theme) => ({
  error: {
    flexBasis: 0,
    flexGrow: 1,
    minHeight: 48,
    alignSelf: 'stretch',
    backgroundColor: colors.red,
  },
  warning: {
    flexBasis: 0,
    flexGrow: 1,
    minHeight: 48,
    alignSelf: 'stretch',
    backgroundColor: `${colors.orange} !important`,
  },
  infobarWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    margin: theme.spacing(0, 0, 1, 0),
    gap: theme.spacing(1),

    '& > div': {
      marginRight: 0,
      marginBottom: 0,
    },
  },
  alertContent: {
    display: 'flex',
    alignItems: 'center',
  },
  alertIcon: {
    fontSize: '1rem',
    lineHeight: 1,
  },
}));
